import { render } from "./Setting.vue?vue&type=template&id=5fcfba34&scoped=true&ts=true"
import script from "./Setting.vue?vue&type=script&lang=ts"
export * from "./Setting.vue?vue&type=script&lang=ts"

import "./Setting.vue?vue&type=style&index=0&id=5fcfba34&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcfba34"]])

export default __exports__